import { useMemo } from 'react'
import { useSurveyProps } from './useSurveyProps'

export const useReplaceSegmentParameters = (url: string): string => {
  const { customParams } = useSurveyProps()

  return useMemo(
    () => Object.entries(customParams || {}).reduce((final, [param, value]) => final.replace(`{${param}}`, value), url),
    [url, customParams]
  )
}
